import React, { useEffect, useState } from 'react';
import { _getCustomerListApi } from '../../services/Redux/Reducer/CustomerSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function VisitorList(props) {

    const dispatch = useDispatch();
    const { fullVisitorList, isLoading } = useSelector((state) => state?.CustomerSlice);

    useEffect(() => {
        dispatch(_getCustomerListApi());
    }, []);

    const shuffleArray = (array) => {
        const copy = [...array];
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    };

    const [visitors, setVisitors] = useState([]);
    // const [loading, setLoading] = useState(true);

    const deduplicatedList = Array.from(new Map(fullVisitorList.map(item => [item.fullName, item])).values());
    useEffect(() => {
        // const timer = setTimeout(() => {
        const shuffled = shuffleArray(deduplicatedList);
        console.log("shuffledshuffled", shuffled)
        setVisitors(shuffled.slice(0, 3));
        //     setLoading(false);
        // }, 4000);

        // return () => clearTimeout(timer);
    }, [fullVisitorList]);

    return (
        <>
            <div className='visitors-section'>
                <div class="bg-white shadow-md">
                    <div class="flex items-center justify-between bg-black text-white px-6 py-4">
                        <h2 class="text-lg font-normal font-osw">VISITORS IN LINE</h2>
                    </div>

                    <div class="lg:px-6 lg:py-4 p-[30px_15px] !pb-0">
                        <div class="flex items-center space-x-2 mb-4">
                            <div class="flex space-x-1">
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                            </div>
                            <p class="text-gray-600 text-sm">Visitors Currently Enrolling</p>
                        </div>

                        <div class="space-y-4 flex justify-center items-center">
                            {isLoading ? <div className="animate-spin relative top-[-30px] rounded-full h-16 w-16 border-t-4 border-sky-700 border-solid mt-10"></div> :
                                <div className='w-full' >{visitors?.map(val => {
                                    return (
                                        <div class="flex items-center border mb-[20px]">
                                            <div class="bg-black text-yellow-500 p-2 min-h-[50px] flex justify-center items-center">
                                                <svg class="h-6 w-6" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"
                                                    xmlns="http://www.w3.org/2000/svg">
                                                    <path stroke-linecap="round" stroke-linejoin="round"
                                                        d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                                </svg>
                                            </div>
                                            <div class="ml-4 py-[5px]">
                                                <p class="text-sm font-bold">New Visitor Enrollment</p>
                                                <p class="text-sm text-gray-600">{`New In-Line - ${val.firstName} ${val.lastName?.charAt(0).toUpperCase()} from ${val.countryCode}`}</p>
                                            </div>
                                        </div>)
                                })}
                                </div>}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
